<template>
  <div v-if="isOpen" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <h3>Registra tus datos</h3>

      <form @submit.prevent="submitFormulario">
        <div class="form-group">
          <label for="personType"><span class="required">*</span> Tipo persona:</label>
          <select id="personType" v-model="formulario.personType" class="form-input" required>
            <option v-for="type in lstTipoPersona" :key="type.id" :value="type.id">{{ type.dt1 }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="documentType"><span class="required">*</span> Tipo documento:</label>
          <select id="documentType" v-model="formulario.documentType" class="form-input" required>
            <option v-for="type in lstDocumentos" :key="type.id" :value="type.id">{{ type.dt1 }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="documentNumber"><span class="required">*</span> Número de Documento:</label>
          <input 
            type="text" 
            id="documentNumber" 
            v-model="formulario.documentNumber" 
            class="form-input" 
            required
            :minlength="formulario.docMax"
            :maxlength="formulario.docMin"
          >
          <small v-if="formulario.documentNumber.length < formulario.docMin || formulario.documentNumber.length > formulario.docMax">
            El número de documento debe tener entre {{ formulario.docMax }} y  {{ formulario.docMin }} caracteres.
          </small>
        </div>

        <div class="form-group" v-if="juridica">
          <label for="razonSocial">Razón social:</label>
          <input type="text" id="razonSocial" v-model="formulario.razonSocial" class="form-input" required>
        </div>

        <div class="form-group" v-if="!juridica">
          <label for="firstName1"><span class="required">*</span> Nombre:</label>
          <input type="text" id="firstName1" v-model="formulario.firstName1" class="form-input" required>
        </div>

        <!-- <div class="form-group" v-if="!juridica">
          <label for="firstName2">Segundo Nombre:</label>
          <input type="text" id="firstName2" v-model="formulario.firstName2" class="form-input">
        </div> -->

        <div class="form-group" v-if="!juridica">
          <label for="lastName1"><span class="required">*</span> Apellido:</label>
          <input type="text" id="lastName1" v-model="formulario.lastName1" class="form-input" required>
        </div>

        <!-- <div class="form-group" v-if="!juridica">
          <label for="lastName2">Segundo Apellido:</label>
          <input type="text" id="lastName2" v-model="formulario.lastName2" class="form-input">
        </div> -->

        <div class="form-group">
          <label for="phoneType"><span class="required">*</span> Tipo teléfono:</label>
          <select id="phoneType" v-model="formulario.phoneType" class="form-input" required>
            <option v-for="type in lstTipoTelefono" :key="type.id" :value="type.id">{{ type.dt1 }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="phoneNumber"><span class="required">*</span> Número de teléfono:</label>
          <input type="tel" id="phoneNumber" v-model="formulario.phoneNumber" class="form-input" required
          :maxlength="10">
        </div>

        <div class="form-group">
          <label for="email"><span class="required">*</span> Correo electrónico:</label>
          <input type="email" id="email" v-model="formulario.email" class="form-input" required>
        </div>

        <div class="form-group" style="display: flex; align-items: center; gap: 8px;">
          <input type="checkbox" id="dataConsent" v-model="formulario.dataConsent" required>
          <label for="dataConsent"><span class="required">*</span> Acepto el tratamiento de datos personales</label>

        </div>

        <div class="modal-buttons">
          <button type="submit" class="reserve-btn" :disabled="isLoading">
            <div v-if="isLoading" class="spinner"></div>
            <span v-if="!isLoading">Guardar</span>
          </button>
          <button type="button" class="cancel-btn" @click="closeModal">Cancelar</button>
        </div>
      </form>
    </div>

  </div>



</template>
  
  <script>
  import * as servicios from "../../servicios";

  export default {
    props: {
      isOpen: {
        type: Boolean,
        required: true
      },
      selectedCarDetails: { 
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {

        formulario: {
          personType: '',
          documentType: '',
          documentNumber: '',
          firstName1: '',
          firstName2: '',
          lastName1: '',
          lastName2: '',
          phoneType: '',
          phoneNumber: '',
          email: '',
          dataConsent: false,
          razonSocial: '',
          docMax:0,
          docMin:0,
          nameDocumentType:'',
          nameTypePerson:"",
        },
      lstTipoPersona: [],
      lstDocumentos: [], 
      isNombreUnoRequired: true, 
      isApellidoUnoRequired: true, 
      isRazonSocialRequied: false, 
      juridica: false, 
      lstTipoTelefono: [],
      lstTipoInteresado:[],
      isLoading: false,

      };
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },

    

      submitFormulario() {
        this.isLoading = true;
        servicios.generarLeadInteresado.generarLeadInteresado(this.formulario, this.selectedCarDetails.detallesAdicionales, this.lstTipoInteresado)
        .then(response => {
          this.$emit('leadGenerated');
          this.closeModal(); 
        })
        .catch(error => {
          console.error("Error al generar el lead", error);
          
        }).finally(() => {
          this.isLoading = false;
        });
    },


    limpiarFormulario() {
      this.formulario.documentNumber = '';
      this.formulario.firstName1 = '';
      this.formulario.firstName2 = '';
      this.formulario.lastName1 = '';
      this.formulario.lastName2 = '';
      this.formulario.phoneNumber = '';
      this.formulario.email = '';
      this.formulario.razonSocial = '';

      this.formulario.documentType = '';
      this.formulario.phoneType = '';
      this.formulario.docMax = 0;
      this.formulario.docMin = 0;
      this.formulario.dataConsent = false;
    },

      consultarTipoPersona() {
        servicios.tipoPersona.tipoPersona().then((response) => {
          this.lstTipoPersona = response.data;
          const aux = response.data.find((i) => i.dt1 === "NATURAL");
          this.formulario.personType = aux.id;
        });
      },

      consultarTipoDocumento(val) {
        this.formulario.nameTypePerson = val.dt1;
        servicios.tipoDocumento.tipoDocumento(val.id).then((response) => {
        this.lstDocumentos = response.data;
        
        const aux = response.data.find(i => i.dt1 === "CEDULA");
        const aux2 = response.data.find(i => i.dt1 === "RUC");

        this.juridica = val.dt1 === 'JURIDICA';
        
        const selectedDocument = aux || aux2 || response.data[0];
        
        if (selectedDocument) {
          this.formulario.documentType = selectedDocument.id;
          this.formulario.docMin = selectedDocument.ndt1;
          this.formulario.docMax = selectedDocument.ndt2;
          this.formulario.nameDocumentType = selectedDocument.dt1;
        }
      });
    },

      consultarTipoTelefono(val) {
        servicios.tipoTelefono.tipoTelefono(val.dt1).then((response) => {
          this.lstTipoTelefono = response.data.Result;
          const auxTelf = response.data.Result.find(x => x.dt1 === 'PERSONAL');
          const auxTelf2 = response.data.Result.find(x => x.dt1 === 'MOVIL TRABAJO');
          this.formulario.phoneType = auxTelf ? auxTelf : auxTelf2;
        });
      },

      validateDocumentNumber() {
        const docNumber = this.formulario.documentNumber;
        const minLength = this.formulario.docMin;
        const maxLength = this.formulario.docMax;

        if (docNumber.length < minLength || docNumber.length > maxLength) {
          alert(`El número de documento debe tener entre ${maxLength}  y  ${minLength} caracteres.`);
          return false;
        }
        return true;
      },

      validarDocumento() {
        const formulario = {
          ci: this.formulario.documentNumber,
          tipoDocumento: this.lstDocumentos.find(doc => doc.id === this.formulario.documentType).dt1, 
          tipoPersona: this.lstTipoPersona.find(person => person.id === this.formulario.personType).dt1,
        };

        servicios.validacionDocumento.validacionDocumento(formulario, this.selectedCarDetails)
          .then(response => {
            if (response.data.bdt) {
            } else {
              this.formulario.documentNumber = ''; 
            }
          })
          .catch(error => {
            this.msnError = error.response.data.dt1
            console.error("Error en la validación del documento:", this.msnError);
          });
      },

      consultarTipoInteresado() {
       
        servicios.tipoInteresado.tipoInteresado().then((response) => {
          this.lstTipoInteresado = response.data
        });
      },

    },

    mounted() {
      this.consultarTipoPersona();
      this.consultarTipoInteresado();
    },

    watch: {
    'formulario.personType': function(newValue) {
      const selectedType = this.lstTipoPersona.find(type => type.id === newValue);

      
      if (selectedType) {
        this.limpiarFormulario();
        this.consultarTipoDocumento(selectedType);
        this.consultarTipoTelefono(selectedType);
      }
    },
    
    'formulario.documentType': function(newValue) {
        const selectedDocument = this.lstDocumentos.find(doc => doc.id === newValue);
        if (selectedDocument) {
          this.formulario.docMin = selectedDocument.ndt1;
          this.formulario.docMax = selectedDocument.ndt2;
        }
        this.formulario.documentNumber = '';
      },

      'formulario.documentNumber': function(newValue) {
        if (newValue.length === this.formulario.docMax) {
          this.validarDocumento();
        }
      },
  },

  created() {},
  
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 90%;
    max-width: 500px;
    max-height: 90vh;
    overflow-y: auto;
    text-align: center;
    position: relative;
  }
  
  .form-group {
    margin-bottom: 15px;
    text-align: left;
  }

  .form-input {
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-sizing: border-box;
  }
  
  .form-input:focus {
    outline: none;
    border-color: #0066cc;
  }

  .modal-buttons {
    display: flex;
    justify-content: space-evenly;
    margin-top: 20px;
  }
  
  .button-container {
    position: relative;
  }
  
  .reserve-btn {
    padding: 10px 20px;
    font-size: 1rem;
    cursor: pointer;
    border: none;
    position: relative; 
    width: 120px; 
    height: 40px; 
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #05141f;
    color: white;
    overflow: hidden;
  }
  
  .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); 
    border: 4px solid transparent;
    border-top: 4px solid #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
  }
  
  .reserve-btn:disabled {
    opacity: 0.6; 
    cursor: not-allowed;
  }
  
  .cancel-btn {
    padding: 10px 20px;
    font-size: 1rem;
    cursor: pointer;
    border: none;
    transition: background-color 0.3s;
    background-color: #0a2a3f;
    color: white;
    margin-right: 10px; 
  }
  
  .cancel-btn:hover {
    background-color: #0a2a3f;
  }

  .required {
    color: red;
    font-weight: bold;
    margin-left: 4px;
  }
  
</style>